import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section id="categories" className="px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <span className="text-xs font-medium text-primary-600 tracking-[0.2em]">COLUMNS</span>
          <h2 className="mt-2 font-heading font-black text-2xl md:text-4xl text-foreground-950">
            栏目总览
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
            日报按栏目归档，订阅你关心的方向即可按需追更，不必在信息流里反复翻找。
          </p>
        </div>
        <Link
          to="/daily"
          className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
        >
          进入日报列表
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/daily?cat=${cat.id}`}
            className="group flex flex-col p-5 rounded-lg border border-background-200 bg-background-100 hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer"
          >
            <div className="flex items-center justify-between">
              <span className="w-11 h-11 rounded-md bg-background-50 border border-background-200 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors`} />
              </span>
              <span className="text-xs text-foreground-500">{cat.count} 条</span>
            </div>
            <h3 className="mt-4 font-heading font-bold text-base text-foreground-950">{cat.name}</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{cat.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-foreground-700 group-hover:text-primary-600 transition-colors">
              查看栏目
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}